<template>
  <ContentSlider
    v-editable="blok"
    :slides="blok.slides"
    :duration="blok.duration ? Number(blok.duration) : 10"
  />
</template>

<script lang="ts" setup>
import type { SbContentSliderStoryblok } from '@/types'

interface Props {
  blok: SbContentSliderStoryblok
}

defineProps<Props>()
</script>
